import React from 'react';
import { CheckIcon, XIcon, UsersIcon, UserXIcon } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-16 md:py-24 relative" data-id="element-13">
      <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-14">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-15">
          {/* Who this is for */}
          <div className="bg-slate-800/30 border border-brand-900/50 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-16">
            <div className="absolute top-0 left-0 w-full h-1 bg-brand-500" data-id="element-17"></div>
            <div className="flex items-center mb-8" data-id="element-18">
              <div className="bg-brand-500/20 p-3 rounded-lg mr-4" data-id="element-19">
                <UsersIcon className="h-8 w-8 text-brand-400" data-id="element-20" />
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-21">
                Para quién es esto
              </h2>
            </div>

            <ul className="space-y-6" data-id="element-22">
              <li className="flex items-start" data-id="element-23">
                <CheckIcon className="h-6 w-6 text-brand-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-24" />
                <span className="text-slate-300" data-id="element-25">
                  Profesionales que negocian acuerdos y necesitan saber si la
                  otra parte es honesta.
                </span>
              </li>
              <li className="flex items-start" data-id="element-26">
                <CheckIcon className="h-6 w-6 text-brand-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-27" />
                <span className="text-slate-300" data-id="element-28">
                  Personas en el mundo de las citas que quieren evitar perder el
                  tiempo con gente falsa.
                </span>
              </li>
              <li className="flex items-start" data-id="element-29">
                <CheckIcon className="h-6 w-6 text-brand-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-30" />
                <span className="text-slate-300" data-id="element-31">
                  Empleados que trabajan en entornos tóxicos y necesitan
                  blindaje contra manipuladores.
                </span>
              </li>
              <li className="flex items-start" data-id="element-32">
                <CheckIcon className="h-6 w-6 text-brand-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-33" />
                <span className="text-slate-300" data-id="element-34">
                  Cualquier persona que busque una ventaja injusta en su
                  comunicación diaria.
                </span>
              </li>
            </ul>
          </div>

          {/* Who this is NOT for */}
          <div className="bg-slate-900/50 border border-red-900/30 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-35">
            <div className="absolute top-0 left-0 w-full h-1 bg-red-500/50" data-id="element-36"></div>
            <div className="flex items-center mb-8" data-id="element-37">
              <div className="bg-red-500/10 p-3 rounded-lg mr-4" data-id="element-38">
                <UserXIcon className="h-8 w-8 text-red-400" data-id="element-39" />
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-40">
                Para quién NO es
              </h2>
            </div>

            <ul className="space-y-6" data-id="element-41">
              <li className="flex items-start" data-id="element-42">
                <XIcon className="h-6 w-6 text-red-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-43" />
                <span className="text-slate-400" data-id="element-44">
                  Personas que buscan técnicas de manipulación para dañar a
                  otros.
                </span>
              </li>
              <li className="flex items-start" data-id="element-45">
                <XIcon className="h-6 w-6 text-red-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-46" />
                <span className="text-slate-400" data-id="element-47">
                  Quienes esperan una "fórmula mágica" que funcione sin observar
                  con atención.
                </span>
              </li>
              <li className="flex items-start" data-id="element-48">
                <XIcon className="h-6 w-6 text-red-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-49" />
                <span className="text-slate-400" data-id="element-50">
                  Terapeutas que buscan un manual clínico (esto es una guía
                  táctica práctica).
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}